import instance from "api";
import {IDynamicTableParams} from "components/DynamicTable";
import {IConsultationType} from "pages/PageConsultations/interfaces";
import {IDictionaryItem} from "components/SimpleDictionary/interfaces";

export const getConsultationTypeList = (data: IDynamicTableParams) => {
    return instance().post("/consultationType/list", data)
        .then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/consultationType/availableColumns")
        .then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/consultationType/availableGroupColumns")
        .then(response => response.data);
}

export const addNewConsultationType = (data: IDictionaryItem) => {
    return instance().post("/consultationType/create",
        {consultationDesc: data.name}).then(response => response.data);
}

export const updateConsultationType = (data: IDictionaryItem) => {
    return instance().post("/consultationType/update",
        {consultationTypeId: data.id, consultationDesc: data.name}).then(response => response.data);
}

export const deleteConsultationType = (consultationTypeId: number) => {
    return instance().post("/consultationType/archive", {consultationTypeId})
        .then(response => response.data);
}

export const recoverConsultationType = (consultationTypeId: number) => {
    return instance().post("/consultationType/recover", {consultationTypeId})
        .then(response => response.data);
}

export const getConsultationType = (consultationTypeId: number) => {
    return instance().post<IConsultationType>("/consultationType/load", {consultationTypeId})
        .then(response => response.data);
}
